<template>
  <section
    class="content-block grid lg:grid-cols-[1fr_auto] items-center pt-10 md:py-20 gap-14 lg:gap-16 xl:gap-28"
  >
    <div class="text-center lg:text-left">
      <h1 class="mb-8 text-4xl font-extrabold leading-tight! text-gray-900 md:text-6xl">
        Sweat for snacks
      </h1>
      <p class="mb-10 text-lg font-normal text-gray-500 lg:text-xl leading-relaxed!">
        Pick your favorite snacks to burn with your activities, automatically added to your Strava
        posts.
      </p>

      <div
        class="flex flex-col sm:flex-row flex-wrap lg:flex-nowrap items-center sm:items-start justify-center lg:justify-start gap-5"
      >
        <div
          class="order-2 sm:order-1 flex flex-col space-y-4 sm:space-y-0 sm:space-x-4 justify-center items-center gap-3"
        >
          <ConnectToStravaButton></ConnectToStravaButton>
          <div class="text-gray-500 flex items-end text-sm gap-1 mt-0!">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              width="256"
              height="256"
              viewBox="0 0 256 256"
              xml:space="preserve"
              class="h-7 w-7"
              alt="svg arrow"
            >
              <g
                style="
                  stroke: none;
                  stroke-width: 0;
                  stroke-dasharray: none;
                  stroke-linecap: butt;
                  stroke-linejoin: miter;
                  stroke-miterlimit: 10;
                  fill: none;
                  fill-rule: nonzero;
                  opacity: 1;
                "
                transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
              >
                <path
                  d="M 17.418 0.016 c 0.036 0.004 0.071 0.005 0.107 0.011 c 0.979 0.13 1.738 0.959 1.738 1.973 v 9.704 c 0 1.104 -0.895 2 -2 2 s -2 -0.895 -2 -2 V 6.385 c -4.224 4.317 -6.945 9.85 -7.78 15.943 c -1.029 7.506 0.929 14.955 5.508 20.987 c 3.769 4.966 8.869 8.338 14.429 10.001 c 1.111 -8.229 5.362 -16.031 12.483 -21.437 c 10.258 -7.788 18.323 -6.538 22.112 -3.101 c 3.889 3.527 4.116 9.518 0.581 15.262 c -1.712 2.782 -4.223 5.44 -7.464 7.9 c -6.883 5.225 -15.387 7.457 -23.949 6.285 c -0.019 -0.002 -0.036 -0.005 -0.055 -0.007 c 0.11 5.796 1.988 11.61 5.754 16.57 c 4.579 6.031 11.232 9.919 18.734 10.946 c 7.503 1.027 14.956 -0.929 20.987 -5.507 c 0 0 0 0 0.001 -0.001 c 2.845 -2.159 5.024 -4.451 6.476 -6.811 c 0.579 -0.94 1.81 -1.234 2.751 -0.655 c 0.94 0.578 1.235 1.81 0.655 2.751 c -1.712 2.783 -4.223 5.441 -7.464 7.901 c -0.001 0.001 -0.003 0.002 -0.004 0.003 c -6.882 5.223 -15.385 7.453 -23.944 6.281 c -8.561 -1.172 -16.153 -5.608 -21.377 -12.49 c -4.491 -5.915 -6.659 -12.896 -6.57 -19.798 c -6.889 -1.848 -12.939 -5.9 -17.321 -11.673 c -4.316 -5.685 -6.59 -12.477 -6.59 -19.492 c 0 -1.478 0.101 -2.967 0.305 -4.456 C 4.447 15.02 7.419 8.865 12.019 4 H 7.559 c -1.104 0 -2 -0.895 -2 -2 s 0.895 -2 2 -2 h 9.704 C 17.316 0 17.366 0.012 17.418 0.016 z M 52.713 48.754 c 2.845 -2.16 5.024 -4.451 6.476 -6.81 c 1.283 -2.085 1.925 -4.122 1.925 -5.911 c 0 -1.721 -0.595 -3.212 -1.787 -4.293 c -2.864 -2.598 -9.233 -2.577 -17.008 3.324 c -6.339 4.812 -10.082 11.791 -10.983 19.128 C 38.646 55.295 46.375 53.565 52.713 48.754 z"
                  style="
                    stroke: none;
                    stroke-width: 1;
                    stroke-dasharray: none;
                    stroke-linecap: butt;
                    stroke-linejoin: miter;
                    stroke-miterlimit: 10;
                    fill: currentColor;
                    fill-rule: nonzero;
                    opacity: 1;
                  "
                  transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round"
                />
              </g>
            </svg>
            <span class="relative top-1.5 flex items-center gap-1">
              Free to use
              <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 18"
              >
                <path
                  d="M17.947 2.053a5.209 5.209 0 0 0-3.793-1.53A6.414 6.414 0 0 0 10 2.311 6.482 6.482 0 0 0 5.824.5a5.2 5.2 0 0 0-3.8 1.521c-1.915 1.916-2.315 5.392.625 8.333l7 7a.5.5 0 0 0 .708 0l7-7a6.6 6.6 0 0 0 2.123-4.508 5.179 5.179 0 0 0-1.533-3.793Z"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <img
        class="max-w-full w-[450px] mx-auto md:-mb-20"
        width="1128"
        height="1382"
        src="/images/strava/hero-preview-post.webp"
        alt="strava preview post"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import ConnectToStravaButton from './ConnectToStravaButton.vue'
</script>

<style scoped>
@reference "../../../assets/css/base.css";

.emoji {
  @apply w-7 h-7 md:h-12 md:w-12 inline-block relative -top-px md:top-[-3px] mx-1;
}
</style>
